// extracted by mini-css-extract-plugin
export default {"titleWrapper":"Footer_titleWrapper__NjOdT","realFooter":"Footer_realFooter__-iksI"};